import { DocumentTransitionMetadata } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export type TransitionMetadataPayload = {
  transition: string;
  workflow: string;
  statusDefinition?: string;
};

export const getApplicationTransitionMetadata = async (
  constructGet: ConstructGet,
  uuid: string,
  definitionName: string,
  workflowName: string,
  data: TransitionMetadataPayload,
): Promise<NonPaginatedResponse<DocumentTransitionMetadata> | undefined> =>
  constructGet(`${APPLICATION_BASE_PATH}/${uuid}/transition/meta`, {
    params: {
      workflow: data.workflow,
      transition: data.transition,
      statusdef: data.statusDefinition,
    },
    headers: {
      [InceptHeader.DefinitionName]: definitionName,
      [InceptHeader.WorkflowName]: workflowName,
    },
  });
